import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=0560a6f7&scoped=true&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"
import style0 from "./interface.vue?vue&type=style&index=0&id=0560a6f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560a6f7",
  null
  
)

component.options.__file = "interface.vue"
export default component.exports